(function($) {

	'use strict';

	var init = function() {

        if($('.fp-search').length > 0) {
            
            manageSearchFilter();

        }

    };
    
    var manageSearchFilter = function() {

        var combinations = null; 

        jQuery.post(
            MyAjax.ajaxurl,
            {
                'action': 'formations_search_filter',
            },
            function(response){

                if(response != 'false'){

                    combinations = JSON.parse(response);
                    
                }
            }
        );

        const filters = new Map();
        filters.set('filter-id', '');
        filters.set('rythm', '')
        filters.set('level', '')
        filters.set('campus', '')

        for(const filter of filters.keys()) {
            const $select = $('#' + filter);
            $select.on('change', function() {
                filters.set(filter, $select.val());
                checkCombinations();
            });
        }

        var checkCombinations = function() {
            for(const [key, value] of filters) {
                $('#' + key + ' option').each(function() {
                    if($(this).val() != '') {
                        if(checkEmpty($(this).val(), key) == true) {
                            $(this).attr('disabled','disabled');
                        } else {
                            $(this).removeAttr('disabled');
                        }
                    }
                });
            }
        }

        var checkEmpty = function(option, key) {
            let found = 0;
            for(const item of combinations) {
                let filterId = true;
                if(filters.get('filter-id') != '' && key != 'filter-id') {
                    let needle = filters.get('filter-id');
                    let haystack = item['filter-id'];
                    filterId = haystack.includes(parseInt(needle));
                }
                let rythm = true;
                if(filters.get('rythm') != '' && key != 'rythm') {
                    let needle = filters.get('rythm');
                    let haystack = item['rythm'];
                    rythm = haystack.includes(needle);
                }
                let level = true;
                if(filters.get('level') != '' && key != 'level') {
                    let needle = filters.get('level');
                    let haystack = item['level'];
                    level = haystack.includes(needle);
                }
                let campus = true;
                if(filters.get('campus') != '' && key != 'campus') {
                    let needle = filters.get('campus');
                    let haystack = item['campus'];
                    campus = haystack.includes(needle);
                }
                let needle = option;
                if(key == 'filter-id') {
                    needle = parseInt(needle);
                }
                let haystack = item[key];
                let thisOpt = haystack.includes(needle);
                if(filterId && rythm && level && campus && thisOpt) {
                    found++;
                }
            }
            if(found > 0) {
                return false;
            } else {
                return true;
            }
        }

    }


	$(document).ready(function() {
		init();
	});

})(jQuery);